const ApiErrors: {[key: string]: string} = {
    '400': '',
    '404': '',
    '500': '',
};

export default ApiErrors;
